import type { StackProps } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';

export const Queries: React.FC<StackProps> = (props) => {
  return (
    <Stack
      direction="row"
      {...props}
      sx={[{
        gap: "10px",
        alignItems: "end"
      }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]} />
  );
};
